(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-horizontal.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-horizontal.js');

'use strict';

const DrawCardContainer = svs.components.tipsen.drawCard.DrawCardContainer;
const DRAW_CARD_VARIANTS = svs.components.tipsen.drawCard.constants.DRAW_CARD_VARIANTS;
const DrawSelectorHeader = svs.components.tipsen.drawSelector.DrawSelectorHeader;
const DrawSelectorLinkItem = svs.components.tipsen.drawSelector.DrawSelectorLinkItem;
const composeDrawTitleForAnalytics = svs.components.tipsen.drawSelector.composeDrawTitleForAnalytics;
const DrawSelectorHorizontal = _ref => {
  var _draws$;
  let _ref$draws = _ref.draws,
    draws = _ref$draws === void 0 ? [] : _ref$draws,
    selectedDrawNumber = _ref.selectedDrawNumber,
    onToggleDrawSelector = _ref.onToggleDrawSelector,
    hasExtraMoneyValue = _ref.hasExtraMoneyValue,
    branding = _ref.branding,
    sportTypes = _ref.sportTypes;
  const drawSelectorClassNames = ['pg_draw_selector', 'pg_draw_selector_horizontal'];
  branding && drawSelectorClassNames.push("pg_draw_selector--".concat(branding));
  return React.createElement("div", {
    className: drawSelectorClassNames.join(' ')
  }, React.createElement(DrawSelectorHeader, {
    blockClassName: "pg_draw_selector_horizontal",
    hasExtraMoneyValue: hasExtraMoneyValue,
    onToggleFunc: onToggleDrawSelector,
    productId: draws === null || draws === void 0 || (_draws$ = draws[0]) === null || _draws$ === void 0 ? void 0 : _draws$.productId,
    sportTypes: sportTypes
  }), React.createElement("ol", null, draws.map(draw => {
    const isSelected = draw.drawNumber === selectedDrawNumber;
    return React.createElement("li", {
      key: draw.drawNumber
    }, React.createElement(DrawSelectorLinkItem, {
      drawNumber: draw.drawNumber,
      drawTitleForAnalytics: composeDrawTitleForAnalytics(draw),
      isLinkItem: !isSelected,
      onToggleDrawSelector: onToggleDrawSelector,
      productId: draw.productId
    }, React.createElement(DrawCardContainer, {
      branding: branding,
      currentDraw: draw,
      drawCardVariant: DRAW_CARD_VARIANTS.HORIZONTAL_LIST_ITEM,
      isSelected: isSelected
    })));
  })));
};
setGlobal('svs.components.tipsen.drawSelector.DrawSelectorHorizontal', DrawSelectorHorizontal);

 })(window);